export type FileOperationAcknowledgeApiResponse = unknown;
export type FileOperationAcknowledgeApiArg = {
  body: FileOperationAcknowledgeRequestBody;
};
export type FileOperationAcknowledgeRequestBody = {
  fileOperationIds: string[];
};
export type GetFileByIdApiResponse = {
  originalFilename: string;
  fileType: 'image' | 'video';
  contentType: string;
  originalUri: string;
  size: number;
  dimensions: {
    width: number;
    height: number;
  };
  uploadedAt: string;
};
export type GetFileByIdApiApiRequestArg = {
  fileId: string;
};

export type SendMultipartUploadRequestResponseBody = {
  files: {fileId: string; parts: {partNumber: number; uploadUri: string}[]}[];
};

export type SendMultipartUploadRequestApiResponse =
  /** status 200  */ SendMultipartUploadRequestResponseBody;

export type SendMultipartUploadRequestApiArg = {
  body: {files: {filename: string; parts: number}[]};
};
export type SendMultipartUploadCompletedApiResponse = /** status 204  */ undefined;

export type SendMultipartUploadCompletedApiArg = {
  fileId: string;
  body: {
    parts: {partNumber: number; etag: string}[];
  };
};
